export const passengerField = {
  checkin_no: "",
  fill_later: false,
  firstname: "",
  lastname: "",
  id_gender: null,
  date_of_birth: "",
  na: false,
  age: null,
  id_country: null,
  id_nationality: null,
  id_passport_no: "",
  hotel_address: "",
  voucher_no: null,
  age_group: null,
};

export const nameInputFieldPassenger = {
  nameCheckinNo: `checkin_no`,
  nameFillLater: `fill_later`,
  nameFirstName: `firstname`,
  nameLastName: `lastname`,
  nameGender: `id_gender`,
  nameDateOfBirth: `date_of_birth`,
  nameNA: `na`,
  nameAge: `age`,
  nameCountry: `id_country`,
  nameNationality: `id_nationality`,
  nameIdPassportNo: `id_passport_no`,
  nameHotelAddress: `hotel_address`,
  nameVoucherNo: `voucher_no`,
};
